import '@formatjs/intl-displaynames/polyfill';
import '@formatjs/intl-displaynames/locale-data/en-150.js';

// TODO other languages, other polyfills, dynamic loading